import { getRegisterFunction } from '../../utils/register.js';
import { OneUxColorPickerElement } from './OneUxColorPickerElement.js';
export const register = getRegisterFunction(OneUxColorPickerElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-color-picker': OneUxColorPickerElement;
    "color-picker-c115ee981c3217a23b14d23368a3792e": OneUxColorPickerElement;
  }
}